import produce from "immer";
import { createAction } from "redux-smart-actions";
import { createSelector } from "reselect";
import { KomutRedux } from "../base/types/KomutRedux";
import { RootState } from "../base/types/RootState";

import { LoginResponseModel } from "./types";

const LOGOUT_ACTION = "LOGOUT_ACTION";
const SET_USER = "SET_USER";
const SET_REFRESH = "SET_REFRESH";
const SET_LOGIN_MODAL_VISIBILITY = "SET_LOGIN_MODAL_VISIBILITY";

export interface AuthReducer {
  user?: LoginResponseModel;
  loginModalVisibility: boolean;
  refresh: boolean;
}

export interface AuthActions {
  logoutAction: any;
  setUser: any;
  setloginModalVisibility: any;
  setRefresh: any;
}

const auth = new KomutRedux<AuthReducer, AuthActions>();

auth.setInitialState({
  user: undefined,
  loginModalVisibility: false,
  refresh: false,
});

auth.setActions({
  logoutAction: createAction(LOGOUT_ACTION),
  setUser: createAction(SET_USER, (payload: LoginResponseModel) => ({
    payload,
  })),
  setloginModalVisibility: createAction(
    SET_LOGIN_MODAL_VISIBILITY,
    (payload: boolean) => ({
      payload,
    })
  ),
  setRefresh: createAction(SET_REFRESH, (payload: boolean) => ({
    payload,
  })),
});

auth.setRedusers(
  produce((draft: AuthReducer, action: any) => {
    switch (action.type) {
      case SET_USER:
        draft.user = action.payload;
        break;
      case SET_LOGIN_MODAL_VISIBILITY:
        draft.loginModalVisibility = action.payload;
        break;
      case LOGOUT_ACTION:
        draft.user = undefined;
        break;
      case SET_REFRESH:
        draft.refresh = action.payload;
        break;
    }
  }, auth.initialState)
);

// ** SELECTORS *** \\
const loginModalVisibilityState = (state: RootState) =>
  state.auth.loginModalVisibility;
export const loginModalVisibilitySelector = createSelector(
  [loginModalVisibilityState],
  (loginModalVisibility) => loginModalVisibility
);

const userState = (state: RootState) => state.auth.user;
export const userSelector = createSelector([userState], (user) => user);

const userTokenState = (state: RootState) => state.auth.user?.AccessToken.Token;
export const getUserToken = createSelector([userTokenState], (token) => token);

const localeState = (state: RootState) => state.language.language.Code;
export const localeSelector = createSelector([localeState], (lang) => lang);

export const getApiParams = createSelector(
  [localeState, userTokenState],
  (lang, token) => {
    return {
      lang,
      token: token || "",
    };
  }
);

// ** SELECTORS *** \\
const refreshState = (state: RootState) => state.auth.refresh;
export const refreshSelector = createSelector([refreshState], (state) => state);

export default auth;
